// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getRateOfProgress(projectId: string, startDate: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/progress_rate?start_date=${startDate}`);
}
